"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./text-field.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SIZE_TO_CLASSNAME_MAP = {
  'extra-small': 'xs',
  'small': 'sm',
  'medium': 'base'
};

var TextField = _react.default.forwardRef(function (props, ref) {
  var _cx;

  var className = props.className,
      style = props.style,
      type = props.type,
      size = props.size,
      rounded = props.rounded,
      disabled = props.disabled,
      iconPrefix = props.iconPrefix,
      iconSuffix = props.iconSuffix,
      color = props.color,
      rest = _objectWithoutProperties(props, ["className", "style", "type", "size", "rounded", "disabled", "iconPrefix", "iconSuffix", "color"]);

  var cNameSize = SIZE_TO_CLASSNAME_MAP[size];
  var computedClassName = (0, _classnames.default)(className, "textfield w-full border outline-none appearance-none", (_cx = {}, _defineProperty(_cx, "text-".concat(cNameSize, " textfield-").concat(cNameSize), cNameSize), _defineProperty(_cx, 'rounded', rounded), _defineProperty(_cx, 'focus:border-blue-400', color === 'default'), _defineProperty(_cx, 'cursor-not-allowed opacity-50 bg-gray-200', disabled), _defineProperty(_cx, 'border-primary', color === 'primary'), _cx));
  var additionalStyles = {};
  if (iconPrefix) additionalStyles.paddingLeft = 40;
  if (iconSuffix) additionalStyles.paddingRight = 40;
  var iconClassName = (0, _classnames.default)('pointer-events-none absolute inset-y-0 right-0 flex items-center px-3', {
    'bg-primary text-white': color === "primary"
  });

  var inputProps = _objectSpread({
    className: computedClassName,
    style: _objectSpread(_objectSpread({}, additionalStyles), style),
    ref: ref,
    disabled: disabled
  }, rest);

  return type === 'textarea' ? _react.default.createElement("textarea", inputProps) : _react.default.createElement("div", {
    className: "w-full relative"
  }, iconPrefix && _react.default.createElement("div", {
    className: (0, _classnames.default)(iconClassName, 'left-0')
  }, iconPrefix), _react.default.createElement("input", _extends({
    type: type
  }, inputProps)), iconSuffix && _react.default.createElement("div", {
    className: (0, _classnames.default)(iconClassName, 'right-0')
  }, iconSuffix));
});

TextField.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  type: _propTypes.default.string,
  size: _propTypes.default.oneOf(['extra-small', 'small', 'medium', null]),
  rounded: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  color: _propTypes.default.oneOf(["default", "primary"]),
  iconPrefix: _propTypes.default.object,
  iconSuffix: _propTypes.default.object
};
TextField.defaultProps = {
  type: 'text',
  size: 'medium',
  rounded: true,
  disabled: false,
  iconPrefix: null,
  iconSuffix: null,
  color: "default"
};

var _default = _react.default.memo(TextField);

exports.default = _default;